<template>
    <OffSetDefault
      :id="'form-odontogramas-' + comp.name"
      title="Odontogramas"
      size="xl"
      :show-close="isEdit"
    >
        <template #body>
            <OdontogramaComponentForm v-if="odontograma" :comp="comp" :technologias="technologias" :ciad-id="ciadId" :odontograma="odontograma" :tipo="'historia'">
            </OdontogramaComponentForm>
        </template>
    </OffSetDefault>
</template>
<script setup lang="ts">
import OdontogramaComponentForm from '@/modules/Asistencial/components/Consultation/Odontology/OdontogramaComponentForm.vue';
import type { ICitaTechnologiasSalud } from '@/modules/Asistencial/interfaces';
import type { IFormComponent } from '@/modules/Administracion/interfaces';
defineProps<{
  ciadId: number
  technologias: ICitaTechnologiasSalud[]
  odontograma: string
  comp: IFormComponent
  isEdit: boolean
}>()
</script>